import { useMerchants } from '@frontend/payments-hooks';

export const useCheckPaymentsEnabled = (locationId: string) => {
  const { hasPayments, chargesEnabled } = useMerchants(locationId, {
    enabled: !!locationId,
  })['firstLocation'];

  return {
    isPaymentsEnabled: hasPayments && chargesEnabled,
  };
};
